import { render, staticRenderFns } from "./OrderchampLogo.vue?vue&type=template&id=2543dee6&scoped=true"
import script from "./OrderchampLogo.vue?vue&type=script&lang=js"
export * from "./OrderchampLogo.vue?vue&type=script&lang=js"
import style0 from "./OrderchampLogo.vue?vue&type=style&index=0&id=2543dee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543dee6",
  null
  
)

export default component.exports